import * as React from 'react';

export const Exclamation = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <circle cx="12" cy="12" r="12" fill="#674808" opacity=".2"/>
            <circle cx="12" cy="12" r="9" fill="#674808"/>
            <g stroke="#FFF" strokeLinejoin="round">
                <path strokeLinecap="round" strokeWidth="1.5" d="M12 7v5"/>
                <path fill="#FFF" strokeWidth=".693" d="M12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
            </g>
        </g>
    </svg>
);
